import { STORAGE_LOCATION } from 'constants/browserCache';
import {
  CookieKeyType,
  LocalStorageKeyType,
  SessionStorageKeyType,
  StorageKeysType,
  StorageLocationType,
} from 'utils/browserCache/types';

const parseStorageItem = (item: string | null) => {
  if (item) {
    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  }
  return null;
};

export const getStorageItem = (location: StorageLocationType, key: StorageKeysType) => {
  const get = {
    [STORAGE_LOCATION.LOCAL_STORAGE]: getLocalStorageItem,
    [STORAGE_LOCATION.SESSION_STORAGE]: getSessionStorageItem,
  };

  return get[location](key);
};

export const updateStorageItem = (
  location: StorageLocationType,
  key: StorageKeysType,
  newObj: unknown,
) => {
  const update = {
    [STORAGE_LOCATION.LOCAL_STORAGE]: updateLocalStorage,
    [STORAGE_LOCATION.SESSION_STORAGE]: updateSessionStorage,
  };

  return update[location](key, newObj);
};

export const deleteStorageItem = (
  location: StorageLocationType,
  key: StorageKeysType | Array<StorageKeysType>,
) => {
  const remove = {
    [STORAGE_LOCATION.LOCAL_STORAGE]: deleteLocalStorage,
    [STORAGE_LOCATION.SESSION_STORAGE]: deleteSessionStorage,
  };
  return remove[location](key);
};

export const getSessionStorageItem = (key: StorageKeysType): any => {
  return parseStorageItem(window.sessionStorage.getItem(key as SessionStorageKeyType));
};

export const getLocalStorageItem = (key: StorageKeysType): any => {
  return parseStorageItem(window.localStorage.getItem(key as SessionStorageKeyType));
};

export const updateSessionStorage = (key: StorageKeysType, newObj: unknown) => {
  window.sessionStorage.setItem(key as SessionStorageKeyType, JSON.stringify(newObj));
};

export const updateLocalStorage = (key: StorageKeysType, newObj: unknown) => {
  window.localStorage.setItem(key as LocalStorageKeyType, JSON.stringify(newObj));
};

export const deleteSessionStorage = (key: StorageKeysType | Array<StorageKeysType>) => {
  const k = key as SessionStorageKeyType | Array<SessionStorageKeyType>;
  if (Array.isArray(k)) k.forEach((_key) => window.sessionStorage.removeItem(_key));
  else window.sessionStorage.removeItem(k);
};

export const deleteLocalStorage = (key: StorageKeysType | Array<StorageKeysType>) => {
  const k = key as LocalStorageKeyType | Array<LocalStorageKeyType>;
  if (Array.isArray(k)) k.forEach((_key) => window.localStorage.removeItem(_key));
  else window.localStorage.removeItem(k);
};

export const getCookieItem = (key: CookieKeyType | string) => {
  if (typeof window === 'undefined') return null;

  const regexp = new RegExp(`(?:^${key}|; *${key})=(.*?)(?:;|$)`, 'g');
  const result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
};

export const setCookieItem = (key: CookieKeyType | string, value: string, days: number) => {
  if (typeof window === 'undefined') return;

  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toString()}`;
  }

  document.cookie = `${key}=${value}${expires}; path=/`;
};

export const deleteCookieItem = (key: CookieKeyType) => {
  if (key) {
    setCookieItem(key, '', -1);
  }
};
